<script setup lang="ts">
import { QRCode } from '@/services/qrcode'
import { useTemplateRef } from 'vue'
import { abbreviatedSha, branch } from '~build/git'

/**
 * Defines a banner to display on top of the page to determine what environment the page is running in.
 */
const MODE = import.meta.env.MODE

const modal = useTemplateRef<HTMLDialogElement>('qrmodal')

const showQrCodeForPage = () => {
  if (!modal.value) {
    return
  }
  modal.value.showModal()
  QRCode.createQRCode({
    code: window.location.href,
    qrCodeElement: modal.value,
  })
}
</script>

<template>
  <div
    id="env-banner"
    :class="MODE"
    class="text-xs hover:opacity-50 cursor-pointer"
    @click="showQrCodeForPage"
  >
    <strong>Env:</strong>&nbsp;<i>{{ MODE }}</i>
    <br />
    <strong>Branch:</strong>&nbsp;
    <i>{{ branch }} [{{ abbreviatedSha }}]</i>
    <dialog ref="qrmodal" class="m-auto"></dialog>
  </div>
</template>

<style lang="scss" scoped>
#env-banner {
  z-index: 2147483638; // max z-index value
  position: fixed;
  top: 0;
  left: 50%;
  translate: -50% 0;
  padding: 6px 12px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  width: max-content;
  max-width: 100%;

  &.development {
    background-color: orangered;
  }

  &.staging {
    background-color: blueviolet;
  }
}
</style>
